import DataTable from "components/DataTable";
import React, { ReactNode } from "react";

interface Column {
  key: string;
  label: string;
  actions?: (row: Row) => React.ReactNode;
  excludeExport?: boolean;
}
interface Row {
  id: number;
  [key: string]: ReactNode;
}
interface DataTableProps {
  data: Row[];
  columns: Column[];
  itemsPerPage?: number;
  loading?: boolean;
  onAdd?: () => void;
}
const Product: React.FC<DataTableProps> = ({
  data,
  columns,
  loading,
  onAdd,
  itemsPerPage
}) => {
  return (
    <DataTable
      data={data}
      columns={columns}
      title={"Product Data"}
      loading={loading}
      onAddBtnClick={onAdd}
      itemsPerPage={itemsPerPage}
    />
  );
};
export default Product;
